(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('userBrandsTreeService', UserBrandsTreeService);

    function UserBrandsTreeService(hUser, $q) {
        var self = this;

        var cachedBrandsTree = {};
        var cachedFavouriteBrandsTree;
        var _emitter = JarEventEmitter.call(self);

        self.EVENTS = {
            BRANDS_UPDATED: 'brands_updated',
        };

        self.BRAND_LIST_LIMIT = 200;

        self.getBrandTreeCache = function (key) {
            return cachedBrandsTree[key];
        };

        self.setBrandTreeCache = function (key, brands) {
            cachedBrandsTree[key] = brands;
        };

        var getFavouriteBrandTreeCache = function () {
            return angular.copy(cachedFavouriteBrandsTree);
        };

        var setFavouriteBrandTreeCache = function (brands) {
            cachedFavouriteBrandsTree = brands;
        };

        self.getUserTLBrandsTree = function (hasAccessClosedLocationsPermission) {
            var defer = $q.defer();

            BrandAPI.getUserBrandsTree(true, true, hasAccessClosedLocationsPermission).then(function (brandsTree) {
                var brands = self.sortBrandList('TEAM_SCHEDULE_BRANDS', brandsTree);
                defer.resolve(angular.copy(brands));
            })
                .catch(function (err) {
                    console.error(err);
                    defer.reject();
                });

            return defer.promise;
        };

        self.getUserBrandsTree = (hasAccessClosedLocationsPermission, includeIsFavourite) => {
            var defer = $q.defer();
            var cache = self.getBrandTreeCache('ALL');

            if (cache) {
                defer.resolve(cache);
            } else {
                BrandAPI.getUserBrandsList(undefined, undefined, undefined, undefined, undefined, hasAccessClosedLocationsPermission, includeIsFavourite)
                    .then((brandsTree) => {
                        const brands = self.sortBrandList('ALL', brandsTree.brands);
                        defer.resolve(brands);
                    })
                    .catch(() => {
                        defer.reject();
                    });
            }
            return defer.promise;
        };

        self.searchUserBrandsTree = (searchTerm, hasAccessClosedLocationsPermission, includeIsFavourite) => {
            var defer = $q.defer();
            var cache = self.getBrandTreeCache(searchTerm);

            if (cache) {
                defer.resolve({brands: cache, fromCache: true});
            } else {
                BrandAPI.getUserBrandsList(self.BRAND_LIST_LIMIT, null, searchTerm, undefined, undefined, hasAccessClosedLocationsPermission, includeIsFavourite)
                    .then((brands) => {
                        defer.resolve(brands);
                    })
                    .catch(() => {
                        defer.reject();
                    });
            }
            return defer.promise;
        };

        self.getUserFavouriteBrandsTree = function () {
            var defer = $q.defer();
            var cache = getFavouriteBrandTreeCache();

            if (cache) {
                defer.resolve(angular.copy(cache));
            } else {
                BrandAPI.getUserFavouriteBrands().then(function (favBrandsTree) {
                    var favourites = self.sortBrandList('FAVOURITES', favBrandsTree.favourite_brands);
                    defer.resolve(angular.copy(favourites));
                }, function () {
                    defer.reject();
                });
            }
            return defer.promise;
        };

        self.getFavouriteBrandsFlatData = function () {
            var favBrands = getFavouriteBrandTreeCache();
            var flatFavouriteList = [];
            if (favBrands) {
                for (var i = 0; i < favBrands.length; i++) {
                    flatFavouriteList.push(...favBrands[i].brands);
                }
                flatFavouriteList.sort(function (brand1, brand2) {
                    var brand1Name = brand1.name.toLowerCase();
                    var brand2Name = brand2.name.toLowerCase();

                    if (brand1Name < brand2Name) {
                        return -1;
                    }
                    if (brand1Name > brand2Name) {
                        return 1;
                    }

                    return 0;
                });
            }
            return flatFavouriteList;
        };

        self.sortBrandList = function (listType, brandsTree) {
            var enterpriseBrands;
            var notEnterpriseBrands;
            var activeBrandId = hUser.getUserContext().brand_id;
            brandsTree.forEach(function (parent) {
                enterpriseBrands = [];
                notEnterpriseBrands = [];
                parent.hasSelectedBrand = parent.id === activeBrandId;
                parent.brands.forEach(function (brand) {
                    brand.profileImage = _.findWhere(brand.media, {'type': 'profile_image'});
                    brand.backgroundMedia = _.findWhere(brand.media, {'type': 'background_image'});
                    brand.media = {
                        profile_media: brand.profileImage,
                        background_media: brand.backgroundMedia,
                    };
                    brand.parent_id = parent.id;

                    if (brand.type === 'enterprise') {
                        enterpriseBrands.push(brand);
                    } else {
                        notEnterpriseBrands.push(brand);
                    }

                    if (brand.is_default || activeBrandId === brand.id) {
                        parent.hasSelectedBrand = true;
                    }
                });
                notEnterpriseBrands.sort(function (brandA, brandB) {
                    return brandA.name.toLowerCase() > brandB.name.toLowerCase() ? 1 : -1;
                });
                parent.brands = enterpriseBrands.concat(notEnterpriseBrands);
            });
            if (listType === 'FAVOURITES') {
                setFavouriteBrandTreeCache(brandsTree);
            } else {
                self.setBrandTreeCache(listType, brandsTree);
            }

            return brandsTree;
        };

        self.updateBrandStarStatus = function (brandId, starValue) {
            cachedFavouriteBrandsTree = null;
            for (var i in cachedBrandsTree) {
                cachedBrandsTree[i].some(function (brandInfo) {
                    var brand = brandInfo.brands.find(function (brand) {
                        return brand.id === brandId;
                    });
                    if (brand) {
                        brand.is_favourite = starValue;
                        return true;
                    }
                });
            }
            self.getUserFavouriteBrandsTree();
            _emitter.trigger(self.EVENTS.BRANDS_UPDATED, brandId, starValue);
        };

        self.checkBrandInFavouriteList = function (brandId) {
            var favouriteBrands = self.getFavouriteBrandsFlatData();
            if (favouriteBrands.findIndex(function (favBrand) {
                return favBrand.id === brandId;
            }) > -1) {
                return true;
            }
            return false;
        };

        self.clearBrandTreeCache = function () {
            cachedBrandsTree = {};
            cachedFavouriteBrandsTree = null;
        };

        self.clearSearchCache = function () {
            var tempCache = {};

            if (cachedBrandsTree['ALL']) {
                tempCache['ALL'] = cachedBrandsTree['ALL'];
            }

            if (cachedBrandsTree['TEAM_SCHEDULE_BRANDS']) {
                tempCache['TEAM_SCHEDULE_BRANDS'] = cachedBrandsTree['TEAM_SCHEDULE_BRANDS'];
            }

            cachedBrandsTree = angular.copy(tempCache);
        };

    }

    UserBrandsTreeService.$inject = ['hUser', '$q'];

})();
